import { render, staticRenderFns } from "./geister.vue?vue&type=template&id=0f028f64&scoped=true&"
import script from "./geister.vue?vue&type=script&lang=js&"
export * from "./geister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f028f64",
  null
  
)

export default component.exports